// The welcome tour's steps, in order (copy in components.WelcomeTour.slides.<key>). `art` picks the step's
// picture in WelcomeArt; `pro` puts the PRO pill after the title
export const WELCOME_SLIDES = [
  { key: 'welcome', art: 'today' },
  { key: 'build', art: 'build' },
  { key: 'guided', art: 'guided' },
  { key: 'progress', art: 'progress' },
  { key: 'alexa', art: 'alexa' },
  { key: 'diet', art: 'diet', pro: true },
  { key: 'start', art: 'start' },
];

const THUMBS_URL = 'https://media.meutreino.fit/exercise-thumbnails';

// Real library exercises (names as the library has them in each language), for the pictures
export const TOUR_EXERCISES = {
  bench: { pt: 'Supino Reto com Barra', en: 'Bench Press (Barbell)', src: `${THUMBS_URL}/00251201-Barbell-Bench-Press_Chest_thumbnail@3x.jpg` },
  row: { pt: 'Remada Curvada com Barra', en: 'Bent Over Row (Barbell)', src: `${THUMBS_URL}/00271201-Barbell-Bent-Over-Row_Back_thumbnail@3x.jpg` },
  curl: { pt: 'Rosca Direta com Barra', en: 'Bicep Curl (Barbell)', src: `${THUMBS_URL}/00311201-Barbell-Curl_Upper-Arms_thumbnail@3x.jpg` },
  raise: { pt: 'Elevação Lateral com Halteres', en: 'Lateral Raise (Dumbbell)', src: `${THUMBS_URL}/03341201-Dumbbell-Lateral-Raise_shoulder_thumbnail@3x.jpg` },
  goblet: { pt: 'Agachamento Goblet com Kettlebell', en: 'Kettlebell Goblet Squat', src: `${THUMBS_URL}/23561201-Kettlebell-Goblet-Squat-(female)_Thighs_thumbnail_@3x.jpg` },
};
